import type { IOrgProjectLocationRepository, LocationExportEntity, LocationExportOptions } from '../repositories/IOrgProjectLocationRepository.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createExportProjectLocationsUseCase({ orgProjectLocationRepository }: Deps) {
  return async function exportProjectLocations(options: LocationExportOptions): Promise<LocationExportEntity[]> {
    return orgProjectLocationRepository.exportByProject(options);
  };
}
